import { useQuery } from '@tanstack/react-query';
import Fetch from '../../util/_fetch';
import {
  defaultResponseHandler,
  useAssetParams,
  useAssetTranslation,
} from '@mss/mss-component-library';

export default function useRemoteProfile() {
  const { assetId } = useAssetParams();
  const { t } = useAssetTranslation();
  return useQuery({
    queryKey: ['profiles', assetId],
    queryFn: async () =>
      (
        await defaultResponseHandler<any[]>({
          request: Fetch.get(`/api/assets/${assetId}/profiles/`),
          t,
        })
      )?.data,
  });
}
